export default {
  totalDelivery: 'Total Delivery',
  totalProcessed: 'Total Processed',
  totalDelivered: 'Total Delivered',
  totalFailed: 'Total Failed',
  successOrder: {
    title: 'Success Order',
    logistic: 'Logistic',
    delivered: 'Delivered'
  },
  failedOrder: {
    title: 'Failed Order',
    logistic: 'Logistic',
    undelivered: 'Undelivered'
  },
  shippingCost: 'Shipping Cost',
  thisMonth: 'This Month',
  lastMonth: 'Last Month',
  onGoingDeliveries: {
    title: 'Ongoing Deliveries',
    date: 'Date',
    sender: 'Sender',
    senderLocation: 'Sender Location',
    receiver: 'Receiver',
    receiverLocation: 'Receiver Location'
  },
  seeAll: 'See All'
}
